import ReducerUtils   from "../../../utils/ReducerUtils"
import Actions        from "../../../model/constant/actions"

const Retrieving = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_ADCOPY_PATTERNS] : (state, action) => action.status
})

export default Retrieving
